import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const BeakerIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="beaker" {...props} />;
};

export { BeakerIcon };
